module.exports = __webpack_public_path__ + "static/media/unpedal-scooter-pin.ee06bd39.svg";